import React, { useState, useEffect } from "react";
import { CardComponent } from "..";
import "./sidebarbody.css";
import { useDataLayerValue } from "../../data-layer";

function SidebarBody({ most }) {
  const [videos, setVideo] = useState([]);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
  
    setVideo(most?.items.map((data) => data));
  }, [most]);

  const handleVideo = (video) => {
    dispatch({
      type: "SET_VIDEO",
      video: video,
    });
    localStorage.setItem("watchVideo", JSON.stringify(video));
  };

  return (
   
    <>
   
      <div style={{backgroundColor:`${!videos&&"#fafafa"}`}} className="sidebarBody">
{/* {videos&&<div className="sidebarBody__loder"><img src="https://icons8.com/preloaders/img/favicons/favicon-194x194.png" alt=""/></div>} */}
        {videos?.map((video) => (
          <CardComponent
            key={video.id}
            id={video.id}
            detail={video}
            videoDetail={handleVideo}
            image={video.snippet.thumbnails.medium.url}
            src={video.snippet.thumbnails.medium.url}
            channelName={video.snippet.channelTitle}
            description={video.snippet.title}
            channelView={video.statistics?.viewCount}
            channelTime={video.snippet.publishedAt}
          />
        ))}
      </div>
    </>
  );
}

export default SidebarBody;
